import styles from './signin/signin.module.css';

/** The brand + spinner card the auth pages show while their search params resolve. */
export function AuthLoadingCard() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.brandRow}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/assets/photonium-logo.svg" alt="" width={38} height={35} className={styles.logoMark} />
            <h1 className={styles.logoText}>Photonium Insight</h1>
          </div>
        </div>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <div className={styles.spinner}></div>
        </div>
      </div>
    </div>
  );
}
